import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);

    // A lazy-loaded chunk can 404 after a new deploy replaces the old build's
    // asset files while a stale service worker/tab is still referencing them.
    // Reload once to pick up the current build instead of showing an error page.
    const isChunkLoadError = /Failed to fetch dynamically imported module|Loading chunk|dynamically imported module/i.test(error?.message || '');
    if (isChunkLoadError && !sessionStorage.getItem('chunk-reload-attempted')) {
      sessionStorage.setItem('chunk-reload-attempted', '1');
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0A1628] text-slate-900 dark:text-white p-8">
          <div className="max-w-md text-center">
            <h1 className="text-3xl font-bold text-red-500">Something went wrong</h1>
            <p className="mt-4 text-slate-500 dark:text-gray-300">{this.state.error?.message}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
